var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0811 60.8103H3.91895C3.36666 60.8103 2.91895 60.3626 2.91895 59.8103V14.6211C2.91895 14.0688 3.36666 13.6211 3.91895 13.6211H25.8357C26.1129 13.6211 26.3777 13.7361 26.5668 13.9388L32.7846 20.6007C32.9737 20.8033 33.2385 20.9184 33.5157 20.9184H60.2973C60.8496 20.9184 61.2973 21.3661 61.2973 21.9184V33.567",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9645 33.4416C45.9645 35.1374 44.5898 36.5121 42.894 36.5121C41.1982 36.5121 39.8235 35.1374 39.8235 33.4416C39.8235 31.7458 41.1982 30.3711 42.894 30.3711C44.5898 30.3711 45.9645 31.7458 45.9645 33.4416Z",
    fill: "#CCCFD1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2974 61.7842V40.8652",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0271 48.1465L61.283 39.8905L69.539 48.1465",
    stroke: "#CCCFD1",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63098 52.2261L20.9245 35.0312L29.2822 45.471L35.0261 38.431L46.2218 52.2261",
    stroke: "#CCCFD1",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapAdd);
export default __webpack_public_path__ + "static/media/icon-map-add.b761b21239a5adb40d655d437b535f87.svg";
export { ForwardRef as ReactComponent };